export default __webpack_public_path__ + "static/media/CNo.37-4.6391121e.jpg";